import type { ExternalTableSchema } from '@packages/table-builder';

/** Replaces legacy useGetEsppParticipants — runtime IDs substituted in endpoint below */
export function buildEsppParticipantsTable(
  offeringPeriodId: string,
  purchasePeriodId: string,
): ExternalTableSchema {
  return {
    metadata: {
      title: 'ESPP Participants',
      entity: 'EsppParticipant',
    },

    dataSource: {
      endpoint:
        '/api/award/api/award/offering-period/{offeringPeriodId}/purchase-period/{purchasePeriodId}/espp-participants'
          .replace('{offeringPeriodId}', offeringPeriodId)
          .replace('{purchasePeriodId}', purchasePeriodId),
      method: 'GET',
      rowIdField: 'esppParticipantId',
      responseMapping: {
        items: 'items',
        totalCount: 'totalCount',
      },
      requestParams: {
        EligibilityStatus: 'filters.eligibilityStatus',
        EnrollmentStatus: 'filters.enrollmentStatus',
        IsEnrolled: 'filters.enrolledStatus',
        IsInvitationEmailSent: 'filters.emailStatus',
        Filter: '',
        MaxResultCount: 'table.pageSize',
        SkipCount: 'table.pageOffset',
        Sorting: 'table.sorting',
      },
      filters: [
        {
          name: 'eligibilityStatus',
          placeholder: 'Eligibility Status',
          type: 'select',
          options: [
            { label: 'Eligible', value: 'Eligible' },
            { label: 'InEligible', value: 'InEligible' },
          ],
        },
        {
          name: 'enrollmentStatus',
          placeholder: 'Enrollment Status',
          type: 'select',
          options: [
            { label: 'Enrolled', value: 'Enrolled' },
            { label: 'NotEnrolled', value: 'NotEnrolled' },
          ],
        },
        {
          name: 'enrolledStatus',
          placeholder: 'Enrolled Status',
          type: 'select',
          options: [
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
          ],
        },
        {
          name: 'emailStatus',
          placeholder: 'Email Sent Status',
          type: 'select',
          options: [
            { label: 'Sent', value: 'true' },
            { label: 'Not Sent', value: 'false' },
          ],
        },
      ],
    },

    columns: [
      {
        field: 'fullName',
        header: 'Participant Details',
        type: 'couple',
        width: 300,
        couple: {
          titleField: 'fullName',
          subtitleField: 'employeeId',
        },
      },
      { field: 'emailAddress', header: 'Email Address', type: 'text', width: 300 },
      {
        field: 'eligibilityStatus',
        header: 'Eligibility Status',
        type: 'badge',
        width: 300,
        align: 'center',
        badge: {
          statusMap: { Eligible: 'success', InEligible: 'info' },
          defaultVariant: 'info',
        },
      },
      {
        field: 'isEnrolled',
        header: 'Enrolled Status',
        type: 'conditional',
        width: 300,
        align: 'center',
        conditionalValues: { true: 'Yes', false: 'No' },
      },
      {
        field: 'enrollmentStatus',
        header: 'Enrollment Status',
        type: 'badge',
        width: 300,
        align: 'center',
        badge: {
          statusMap: { Enrolled: 'success', NotEnrolled: 'info' },
          defaultVariant: 'info',
        },
      },
      {
        field: 'invitationEmailSent',
        header: 'Email Status',
        type: 'badge',
        width: 300,
        align: 'center',
        badge: {
          statusMap: { true: 'success', false: 'info' },
          defaultVariant: 'info',
        },
        conditionalValues: { true: 'Sent', false: 'Not Sent' },
      },
      {
        field: 'numberOfChangesInChangeWindow',
        header: 'Change Window',
        type: 'text',
        width: 300,
        align: 'center',
      },
      {
        field: 'numberOfChangesInEnrollmentWindow',
        header: 'Enrollment Window',
        type: 'text',
        width: 300,
        align: 'center',
      },
      {
        field: 'residualCashAmount',
        header: 'Residual Cash Amount',
        type: 'text',
        width: 300,
        align: 'center',
      },
      {
        field: 'previousPeriodResidualCashAmount',
        header: 'Previous Residual Cash Amount',
        type: 'text',
        width: 300,
        align: 'center',
      },
      {
        field: 'totalContribToDateForPurchasePeriod',
        header: 'Total Purchase Period',
        type: 'text',
        width: 300,
        align: 'center',
      },
    ],

    actions: {
      row: [{ id: 'SEND_EMAIL_ESPP_PARTICIPANT', label: 'Send Email' }],
    },

    features: {
      search: { enabled: false },
      pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    },
  };
}
